import {
    CloseModalIconWrapper,
    PrintPDFButton,
    ShareModalBody,
    ShareModalBottomRow,
    ShareModalHeader,
    ShareModalSend,
    ShareModalSendRow,
    ShareModalUrlButton,
    ShareModalUrlField
} from "./styles";
import {FlexBox, HintTooltip, useBreakpoint, useToasts} from "@brg/ui";
import {CloseModalIcon} from "../../../core/modules/CloseIconNew";
import {LayoutConst, useModal} from "../../../core";
import {SharedIconList} from "./icons/SharedIconList";
import {CopyIcon} from "./icons/CopyIcon";
import {FC, useCallback, useMemo} from "react";
import {API, CardGatewayAPI, Endpoints, Project, TFile} from "@brg/api";
import {getImgUrlFromList} from "./actions/getImgUrlFromList";
import {copyLinkText, createCopyLinkProjectFn} from "../../helpers/copyLink";
import {createCopyLinkBookFn} from "../../../_deziiign/books/helpers/copyLink";
import {CreateLinkTo} from "../../constants/linkTo";
import {ArrowTopRightIcon} from "./icons/ArrowIcons";
import {useTranslation} from "react-i18next";
import { ProfileUtils, useAssociatedProfile } from "@brg/auth";
import DownloadIcon from "shared/assets/24/Download";
import { AppTester } from "supporting";
import {useSelector} from "react-redux";
import {SP_VOTE_COLLECTION_SIGN} from "../../pages/VotesAdmin/constants";
import {SuccessModalTypes} from "../artzLegalsModal/SuccessModal";

interface ShareModalProps {
    projectId?: string,
    project?: Project,
    images?: TFile[],
    isBook?: boolean,
    title?: string,
    cardId?: string,
    projectStatus?: number,
    onPrint?: () => void,
    isPresentation?: boolean
    childEntities?: {entityType: string, entityId: string}[]
    setChildEntities?: (val: {entityType: string, entityId: string}[]) => void;
    customCopyUrl?: string;
}

export const ShareModal: FC<ShareModalProps> =
    ({
        projectId,
        project,
        images = [],
        isBook,
        title,
        cardId,
        childEntities,
        setChildEntities,
        projectStatus,
        onPrint,
        isPresentation,
        customCopyUrl
    }) => {

    const modal = useModal();
    const profile = useAssociatedProfile();
    const isModer = useMemo(() => profile && ProfileUtils.isModer(profile),[profile]);
    const is744 = useBreakpoint(LayoutConst.screen.s - 1);
    const toasts = useToasts();
    const {t} = useTranslation();
    //const [userSigned, setUserSigned] = useState(false);
    const vtype = useSelector((state: any) => state.vt.projectVType);
    const isCollectionVoting = useMemo(() => !!project?.contexts?.includes(SP_VOTE_COLLECTION_SIGN), [project])
    const isProPresentation = useMemo(() => !!project?.contexts?.includes('propresentation')
        || !!project?.contexts?.includes('prohse'), [project])
      
    const shouldDisplayPresentationEditor = useMemo(() => (['fluid', 'container', 't-shape', 'fixed-ratio-large', 'fixed-ratio-small', 'shadow'].includes(vtype)), [vtype])
    const isGameDeziiign = AppTester.isGameDeziiign();

    const isDisabled = useMemo(() => ![1,6,9].includes(projectStatus || 0), [projectStatus])
    const isSendImagesToArtzWorkDisabled = true;
    const isArtzSendDisabled = isDisabled || isSendImagesToArtzWorkDisabled;

    const isVisibleSendToArtzWorkBtn = useMemo(() => ((isModer || (profile?.accountId === project?.author?.accountId)) && !isCollectionVoting), [isModer, cardId, isCollectionVoting, profile, project])
    const isVisibleSendToCompetitionBtn = useMemo(() => (isModer && profile?.accountId === project?.author?.accountId), [profile, project, isModer])

    const isShouldDisplaySendToMediiiaButton = useMemo(() => {
        if (customCopyUrl) return false;
        // @ts-ignore
        const isOwner = [project?.author, project?.coAuthors]?.some(({ accountId }) => {
            return accountId === profile?.accountId
        })
        return (isOwner || isModer) && isProPresentation
    }, [profile, isModer, isProPresentation, project])

    const isAuthor = useMemo(() => {
        if (!profile?.accountId || !project) return false
        return profile.accountId === project.author?.accountId
    }, [profile, project])

    const imgUrl = useMemo(
        () => (images?.length ? getImgUrlFromList(images) : null),
        [images]
    );
    const copyLink = useMemo(() => {
        if (customCopyUrl) return customCopyUrl;
        return window.location.origin + (isBook ? CreateLinkTo.book(projectId || '') : CreateLinkTo.project(projectId || ''));
    }, [customCopyUrl, isBook, projectId]);
    const copyLinkFn = isBook ? createCopyLinkBookFn(toasts, t) : createCopyLinkProjectFn(toasts, t);

    const onCopyLinkClick = useCallback(() => {
        if (customCopyUrl) {
            copyLinkText(customCopyUrl, toasts, t);
            return;
        }
        copyLinkFn(projectId || '');
    }, [customCopyUrl, copyLinkFn, projectId, toasts, t]);

    const AcceptSign = () => {
        if (profile && projectId) {
            API.request().endpoint(Endpoints.gateway)
            .url('/legal/api/UserSign/AcceptDocumentSign')
            .post()
            .body({
                documentId: "project_sale",
                userId: profile?.accountId,
                entity: {
                    entityId: projectId,
                    entityType: 'project'
                }
            })
            .release()
            .then((r) => {
                if (r.status  === 200) {
                    //setUserSigned(true);
                }
            })
        }
    }

    const sendToArtsWork = useCallback((id: string) => {
        modal.hide();

        modal.show('artz-legals-load');

            CardGatewayAPI.AddByProject(
                { projectId: id }
            )
            .then((v) => v.json())
            .then((res) => {
                if (res && res?.cardId) {
                    modal.hide();
                    setChildEntities && setChildEntities([...(childEntities || []), {entityId: res?.cardId || '', entityType: "card"}]);
                    modal.show('artz-legals-success', {
                        id,
                        cardId: res?.cardId,
                        onClose: () => modal.hide(),
                    })
                    AcceptSign();
                    return;
                }

                setTimeout(() => {
                    modal.hide();
                }, 2000)

                setTimeout(() => {
                    modal.show('artz-legals-error', {
                        onClose: () => modal.hide(),
                        onClick: () => sendToArtsWork(projectId ?? ''),
                    })
                }, 2000)
                return;
            })
            .catch((err) => {
                setTimeout(() => {
                    modal.show('artz-legals-error', {
                        onClose: () => modal.hide(),
                        onClick: () => sendToArtsWork(projectId ?? ''),
                    })
                }, 2000)
            })

    }, [modal, projectId, setChildEntities, childEntities])


    const checkSignDocument = useCallback(() => {
        modal.hide();
            
        modal.show('artz-legals-load');

        if (profile && projectId) {
            API.request().endpoint(Endpoints.gateway)
            .url('/legal/api/UserSign/CheckSignDocument')
            .addQuery('documentId',  "project_sale")
            .addQuery('userId', profile?.accountId)
            .addQuery('entityId', projectId)
            .addQuery('entityType', 'project')
            .get()
            .release()
            .then((r) => {
                if (!Boolean(r)) {
                    //setUserSigned(true);
                    modal.hide();
            
                    modal.show('artz-legals-load');
            
                    setTimeout(() => {
                        modal.hide();
                    }, 2000)
            
                    setTimeout(() => {
                        modal.show('artz-legals', {
                            onClick: sendToArtsWork,
                            onClose: () => modal.hide(),
                            projectId
                        })
                    }, 2000)
                    return;
                }
                sendToArtsWork(projectId ?? '')
            })
            .catch((err) => {
                setTimeout(() => {
                    modal.show('artz-legals-error', {
                        onClose: () => modal.hide(),
                        onClick: () => checkSignDocument(),
                    })
                }, 2000)
            })
        }
    }, [profile, projectId, modal, sendToArtsWork])

     const onSendImages = useCallback(() => {
         modal.show('image-sent', {
             project
         })
     }, [project])

     const onSendToCompetition = useCallback(() => {
        modal.show('sent-to-competition', {
            project
        })
    }, [project, modal])

     const onSendToLectureMedia = useCallback(() => {
         API.request()
             .endpoint(Endpoints.geograffee)
             .url(`/api/Project/UpdateContexts`)
             .post()
             .body({
                 projectId: project?.projectId,
                 contexts: [{
                     context: 'medialecture',
                     operation: 1,
                 },{
                     context: 'prohse',
                     operation: 0,
                 },{
                     context: 'propresentation',
                     operation: 0,
                 },],
             })
             .send()
             .then(r => {
                 modal.show('artz-legals-success', {cardId: project?.projectId, type: SuccessModalTypes.LECTURE_MEDIIIA});
             })
     }, [project, modal])

     
    return <ShareModalBody>
        <FlexBox justify="space-between" align={"center"} style={{marginRight: '5px', position: 'relative'}}>
            <FlexBox align="center" style={{ gap: 16 }}>
                <ShareModalHeader>{t("sharing.title")}</ShareModalHeader>
            </FlexBox>
            <CloseModalIconWrapper><CloseModalIcon onClick={() => modal.hide()} width={22} height={22} /></CloseModalIconWrapper>
        </FlexBox>
        <SharedIconList title={title || ''} imgUrl={imgUrl} link={copyLink}/>
        <FlexBox justify="space-between" align={"center"} style={{columnGap: '24px', minWidth: 0}}>
            {!is744 && <ShareModalUrlField>
                <span>
                {`${copyLink}`}
                </span>
            </ShareModalUrlField>}
            <ShareModalUrlButton isGameDeziiign={isGameDeziiign} onClick={onCopyLinkClick}>
                {is744 ? <><CopyIcon/><span>{t("sharing.copy_link")}</span></> : <span>{t("sharing.copy")}</span>}
            </ShareModalUrlButton>
        </FlexBox>
        {!!projectId && !customCopyUrl && <ShareModalBottomRow>
            <ShareModalSendRow>
                {isVisibleSendToCompetitionBtn && (
                    <ShareModalSend isDisabled={isDisabled} onClick={() => isDisabled ? {} : onSendToCompetition()}>
                        <span className={'send-word'}>
                            {t("sharing.send_to")} 
                        </span>
                        <span>&nbsp;</span>
                        <span
                            style={{color: '#146DEE'}}
                        >competition</span>
                        <span>&nbsp;</span>
                        <div style={{marginTop: '2px', marginLeft: '4px'}}><ArrowTopRightIcon/></div>
                    </ShareModalSend>
                )}
                {isShouldDisplaySendToMediiiaButton && (
                    <ShareModalSend isDisabled={isDisabled} onClick={() => isDisabled ? {} : onSendToLectureMedia()}>
                        <span className={'send-word'}>
                            {t("sharing.send_to")} 
                        </span>
                        <span>&nbsp;</span>
                        <span
                            style={{color: '#609af0'}}
                        >lecture</span>
                        <span
                            style={{color: '#151514'}}
                        >.mediiia</span>
                        <div style={{marginTop: '2px', marginLeft: '4px'}}><ArrowTopRightIcon/></div>
                    </ShareModalSend>
                )}
                {isVisibleSendToArtzWorkBtn && (
                    <HintTooltip
                        text={t("nav.mediiia.coming_soon")}
                        positionY="top"
                        onWhiteBg
                        noArrow
                        z={10000}
                    >
                        <ShareModalSend
                            isDisabled={isArtzSendDisabled}
                            onClick={() => {
                                if (isArtzSendDisabled) return;
                                onSendImages();
                            }}
                        >
                            <span className="send-word">{t("sharing.send_images_to")} </span>
                            <span>&nbsp;</span>
                            <span style={{ color: isArtzSendDisabled ? '#151514' : '#146DEE' }}>a</span>
                            <span style={{ color: isArtzSendDisabled ? '#151514' : '#EB5757' }}>r</span>
                            <span style={{ color: isArtzSendDisabled ? '#151514' : '#27AE60' }}>t</span>
                            <span style={{ color: isArtzSendDisabled ? '#151514' : '#F9C200' }}>z</span>
                            <span style={{ color: isArtzSendDisabled ? '#151514' : '#146DEE' }}>.</span>
                            <span style={{ color: isArtzSendDisabled ? '#151514' : '#146DEE' }}>w</span>
                            <span style={{ color: isArtzSendDisabled ? '#151514' : '#EB5757' }}>o</span>
                            <span style={{ color: isArtzSendDisabled ? '#151514' : '#27AE60' }}>r</span>
                            <span style={{ color: isArtzSendDisabled ? '#151514' : '#F9C200' }}>k</span>
                            <div style={{ marginTop: '2px', marginLeft: '4px' }}><ArrowTopRightIcon /></div>
                        </ShareModalSend>
                    </HintTooltip>
                )}
            </ShareModalSendRow>
            {shouldDisplayPresentationEditor && !project?.contexts?.includes('lmsproject') && profile?.accountId && (
                <PrintPDFButton onClick={onPrint}>
                    {!is744 && <DownloadIcon/>}
                    {t("print_project")}
                </PrintPDFButton>
            )}
        </ShareModalBottomRow>}
    </ShareModalBody>
}import {
    CloseModalIconWrapper,
    PrintPDFButton,
    ShareModalBody,
    ShareModalBottomRow,
    ShareModalHeader,
    ShareModalSend,
    ShareModalSendRow,
    ShareModalUrlButton,
    ShareModalUrlField
} from "./styles";
import {FlexBox, HintTooltip, useBreakpoint, useToasts} from "@brg/ui";
import {CloseModalIcon} from "../../../core/modules/CloseIconNew";
import {LayoutConst, useModal} from "../../../core";
import {SharedIconList} from "./icons/SharedIconList";
import {CopyIcon} from "./icons/CopyIcon";
import {FC, useCallback, useMemo} from "react";
import {API, CardGatewayAPI, Endpoints, Project, TFile} from "@brg/api";
import {getImgUrlFromList} from "./actions/getImgUrlFromList";
import {copyLinkText, createCopyLinkProjectFn} from "../../helpers/copyLink";
import {createCopyLinkBookFn} from "../../../_deziiign/books/helpers/copyLink";
import {CreateLinkTo} from "../../constants/linkTo";
import {ArrowTopRightIcon} from "./icons/ArrowIcons";
import {useTranslation} from "react-i18next";
import { ProfileUtils, useAssociatedProfile } from "@brg/auth";
import DownloadIcon from "shared/assets/24/Download";
import { AppTester } from "supporting";
import {useSelector} from "react-redux";
import {SP_VOTE_COLLECTION_SIGN} from "../../pages/VotesAdmin/constants";
import {SuccessModalTypes} from "../artzLegalsModal/SuccessModal";

interface ShareModalProps {
    projectId?: string,
    project?: Project,
    images?: TFile[],
    isBook?: boolean,
    title?: string,
    cardId?: string,
    projectStatus?: number,
    onPrint?: () => void,
    isPresentation?: boolean
    childEntities?: {entityType: string, entityId: string}[]
    setChildEntities?: (val: {entityType: string, entityId: string}[]) => void;
    customCopyUrl?: string;
}

export const ShareModal: FC<ShareModalProps> =
    ({
        projectId,
        project,
        images = [],
        isBook,
        title,
        cardId,
        childEntities,
        setChildEntities,
        projectStatus,
        onPrint,
        isPresentation,
        customCopyUrl
    }) => {

    const modal = useModal();
    const profile = useAssociatedProfile();
    const isModer = useMemo(() => profile && ProfileUtils.isModer(profile),[profile]);
    const is744 = useBreakpoint(LayoutConst.screen.s - 1);
    const toasts = useToasts();
    const {t} = useTranslation();
    //const [userSigned, setUserSigned] = useState(false);
    const vtype = useSelector((state: any) => state.vt.projectVType);
    const isCollectionVoting = useMemo(() => !!project?.contexts?.includes(SP_VOTE_COLLECTION_SIGN), [project])
    const isProPresentation = useMemo(() => !!project?.contexts?.includes('propresentation')
        || !!project?.contexts?.includes('prohse'), [project])
      
    const shouldDisplayPresentationEditor = useMemo(() => (['fluid', 'container', 't-shape', 'fixed-ratio-large', 'fixed-ratio-small', 'shadow'].includes(vtype)), [vtype])
    const isGameDeziiign = AppTester.isGameDeziiign();

    const isDisabled = useMemo(() => ![1,6,9].includes(projectStatus || 0), [projectStatus])
    const isSendImagesToArtzWorkDisabled = true;
    const isArtzSendDisabled = isDisabled || isSendImagesToArtzWorkDisabled;

    const isVisibleSendToArtzWorkBtn = useMemo(() => ((isModer || (profile?.accountId === project?.author?.accountId)) && !isCollectionVoting), [isModer, cardId, isCollectionVoting, profile, project])
    const isVisibleSendToCompetitionBtn = useMemo(() => (isModer && profile?.accountId === project?.author?.accountId), [profile, project, isModer])

    const isShouldDisplaySendToMediiiaButton = useMemo(() => {
        if (customCopyUrl) return false;
        // @ts-ignore
        const isOwner = [project?.author, project?.coAuthors]?.some(({ accountId }) => {
            return accountId === profile?.accountId
        })
        return (isOwner || isModer) && isProPresentation
    }, [profile, isModer, isProPresentation, project])

    const isAuthor = useMemo(() => {
        if (!profile?.accountId || !project) return false
        return profile.accountId === project.author?.accountId
    }, [profile, project])

    const imgUrl = useMemo(
        () => (images?.length ? getImgUrlFromList(images) : null),
        [images]
    );
    const copyLink = useMemo(() => {
        if (customCopyUrl) return customCopyUrl;
        return window.location.origin + (isBook ? CreateLinkTo.book(projectId || '') : CreateLinkTo.project(projectId || ''));
    }, [customCopyUrl, isBook, projectId]);
    const copyLinkFn = isBook ? createCopyLinkBookFn(toasts, t) : createCopyLinkProjectFn(toasts, t);

    const onCopyLinkClick = useCallback(() => {
        if (customCopyUrl) {
            copyLinkText(customCopyUrl, toasts, t);
            return;
        }
        copyLinkFn(projectId || '');
    }, [customCopyUrl, copyLinkFn, projectId, toasts, t]);

    const AcceptSign = () => {
        if (profile && projectId) {
            API.request().endpoint(Endpoints.gateway)
            .url('/legal/api/UserSign/AcceptDocumentSign')
            .post()
            .body({
                documentId: "project_sale",
                userId: profile?.accountId,
                entity: {
                    entityId: projectId,
                    entityType: 'project'
                }
            })
            .release()
            .then((r) => {
                if (r.status  === 200) {
                    //setUserSigned(true);
                }
            })
        }
    }

    const sendToArtsWork = useCallback((id: string) => {
        modal.hide();

        modal.show('artz-legals-load');

            CardGatewayAPI.AddByProject(
                { projectId: id }
            )
            .then((v) => v.json())
            .then((res) => {
                if (res && res?.cardId) {
                    modal.hide();
                    setChildEntities && setChildEntities([...(childEntities || []), {entityId: res?.cardId || '', entityType: "card"}]);
                    modal.show('artz-legals-success', {
                        id,
                        cardId: res?.cardId,
                        onClose: () => modal.hide(),
                    })
                    AcceptSign();
                    return;
                }

                setTimeout(() => {
                    modal.hide();
                }, 2000)

                setTimeout(() => {
                    modal.show('artz-legals-error', {
                        onClose: () => modal.hide(),
                        onClick: () => sendToArtsWork(projectId ?? ''),
                    })
                }, 2000)
                return;
            })
            .catch((err) => {
                setTimeout(() => {
                    modal.show('artz-legals-error', {
                        onClose: () => modal.hide(),
                        onClick: () => sendToArtsWork(projectId ?? ''),
                    })
                }, 2000)
            })

    }, [modal, projectId, setChildEntities, childEntities])


    const checkSignDocument = useCallback(() => {
        modal.hide();
            
        modal.show('artz-legals-load');

        if (profile && projectId) {
            API.request().endpoint(Endpoints.gateway)
            .url('/legal/api/UserSign/CheckSignDocument')
            .addQuery('documentId',  "project_sale")
            .addQuery('userId', profile?.accountId)
            .addQuery('entityId', projectId)
            .addQuery('entityType', 'project')
            .get()
            .release()
            .then((r) => {
                if (!Boolean(r)) {
                    //setUserSigned(true);
                    modal.hide();
            
                    modal.show('artz-legals-load');
            
                    setTimeout(() => {
                        modal.hide();
                    }, 2000)
            
                    setTimeout(() => {
                        modal.show('artz-legals', {
                            onClick: sendToArtsWork,
                            onClose: () => modal.hide(),
                            projectId
                        })
                    }, 2000)
                    return;
                }
                sendToArtsWork(projectId ?? '')
            })
            .catch((err) => {
                setTimeout(() => {
                    modal.show('artz-legals-error', {
                        onClose: () => modal.hide(),
                        onClick: () => checkSignDocument(),
                    })
                }, 2000)
            })
        }
    }, [profile, projectId, modal, sendToArtsWork])

     const onSendImages = useCallback(() => {
         modal.show('image-sent', {
             project
         })
     }, [project])

     const onSendToCompetition = useCallback(() => {
        modal.show('sent-to-competition', {
            project
        })
    }, [project, modal])

     const onSendToLectureMedia = useCallback(() => {
         API.request()
             .endpoint(Endpoints.geograffee)
             .url(`/api/Project/UpdateContexts`)
             .post()
             .body({
                 projectId: project?.projectId,
                 contexts: [{
                     context: 'medialecture',
                     operation: 1,
                 },{
                     context: 'prohse',
                     operation: 0,
                 },{
                     context: 'propresentation',
                     operation: 0,
                 },],
             })
             .send()
             .then(r => {
                 modal.show('artz-legals-success', {cardId: project?.projectId, type: SuccessModalTypes.LECTURE_MEDIIIA});
             })
     }, [project, modal])

     
    return <ShareModalBody>
        <FlexBox justify="space-between" align={"center"} style={{marginRight: '5px', position: 'relative'}}>
            <FlexBox align="center" style={{ gap: 16 }}>
                <ShareModalHeader>{t("sharing.title")}</ShareModalHeader>
            </FlexBox>
            <CloseModalIconWrapper><CloseModalIcon onClick={() => modal.hide()} width={22} height={22} /></CloseModalIconWrapper>
        </FlexBox>
        <SharedIconList title={title || ''} imgUrl={imgUrl} link={copyLink}/>
        <FlexBox justify="space-between" align={"center"} style={{columnGap: '24px', minWidth: 0}}>
            {!is744 && <ShareModalUrlField>
                <span>
                {`${copyLink}`}
                </span>
            </ShareModalUrlField>}
            <ShareModalUrlButton isGameDeziiign={isGameDeziiign} onClick={onCopyLinkClick}>
                {is744 ? <><CopyIcon/><span>{t("sharing.copy_link")}</span></> : <span>{t("sharing.copy")}</span>}
            </ShareModalUrlButton>
        </FlexBox>
        {!!projectId && !customCopyUrl && <ShareModalBottomRow>
            <ShareModalSendRow>
                {isVisibleSendToCompetitionBtn && (
                    <ShareModalSend isDisabled={isDisabled} onClick={() => isDisabled ? {} : onSendToCompetition()}>
                        <span className={'send-word'}>
                            {t("sharing.send_to")} 
                        </span>
                        <span>&nbsp;</span>
                        <span
                            style={{color: '#146DEE'}}
                        >competition</span>
                        <span>&nbsp;</span>
                        <div style={{marginTop: '2px', marginLeft: '4px'}}><ArrowTopRightIcon/></div>
                    </ShareModalSend>
                )}
                {isShouldDisplaySendToMediiiaButton && (
                    <ShareModalSend isDisabled={isDisabled} onClick={() => isDisabled ? {} : onSendToLectureMedia()}>
                        <span className={'send-word'}>
                            {t("sharing.send_to")} 
                        </span>
                        <span>&nbsp;</span>
                        <span
                            style={{color: '#609af0'}}
                        >lecture</span>
                        <span
                            style={{color: '#151514'}}
                        >.mediiia</span>
                        <div style={{marginTop: '2px', marginLeft: '4px'}}><ArrowTopRightIcon/></div>
                    </ShareModalSend>
                )}
                {isVisibleSendToArtzWorkBtn && (
                    <HintTooltip
                        text={t("nav.mediiia.coming_soon")}
                        positionY="top"
                        onWhiteBg
                        noArrow
                        z={10000}
                    >
                        <ShareModalSend
                            isDisabled={isArtzSendDisabled}
                            onClick={() => {
                                if (isArtzSendDisabled) return;
                                onSendImages();
                            }}
                        >
                            <span className="send-word">{t("sharing.send_images_to")} </span>
                            <span>&nbsp;</span>
                            <span style={{ color: isArtzSendDisabled ? '#151514' : '#146DEE' }}>a</span>
                            <span style={{ color: isArtzSendDisabled ? '#151514' : '#EB5757' }}>r</span>
                            <span style={{ color: isArtzSendDisabled ? '#151514' : '#27AE60' }}>t</span>
                            <span style={{ color: isArtzSendDisabled ? '#151514' : '#F9C200' }}>z</span>
                            <span style={{ color: isArtzSendDisabled ? '#151514' : '#146DEE' }}>.</span>
                            <span style={{ color: isArtzSendDisabled ? '#151514' : '#146DEE' }}>w</span>
                            <span style={{ color: isArtzSendDisabled ? '#151514' : '#EB5757' }}>o</span>
                            <span style={{ color: isArtzSendDisabled ? '#151514' : '#27AE60' }}>r</span>
                            <span style={{ color: isArtzSendDisabled ? '#151514' : '#F9C200' }}>k</span>
                            <div style={{ marginTop: '2px', marginLeft: '4px' }}><ArrowTopRightIcon /></div>
                        </ShareModalSend>
                    </HintTooltip>
                )}
            </ShareModalSendRow>
            {shouldDisplayPresentationEditor && !project?.contexts?.includes('lmsproject') && profile?.accountId && (
                <PrintPDFButton onClick={onPrint}>
                    {!is744 && <DownloadIcon/>}
                    {t("print_project")}
                </PrintPDFButton>
            )}
        </ShareModalBottomRow>}
    </ShareModalBody>
}